import React, { useEffect } from 'react';
import { ControlsSC } from './local-controls.styled';
import { ReactComponent as CallEndIcon } from '../../../../../assets/svg/twilio/call-end.svg';
import { ReactComponent as MicrophoneIcon } from '../../../../../assets/svg/twilio/microphone.svg';
import { ReactComponent as MicrophoneMutedIcon } from '../../../../../assets/svg/twilio/microphone-off.svg';
import { ReactComponent as CameraIcon } from '../../../../../assets/svg/twilio/camera.svg';
import { ReactComponent as CameraOffIcon } from '../../../../../assets/svg/twilio/camera-off.svg';
import { ReactComponent as SpeakerIcon } from '../../../../../assets/svg/twilio/speaker.svg';
import { ReactComponent as SpeakerOffIcon } from '../../../../../assets/svg/twilio/speaker-off.svg';
import { ReactComponent as ExpandIcon } from '../../../../../assets/svg/twilio/expand.svg';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../../../store/ducks/twilio';
import TStore from '../../../../../types/store';
import { actions as eVisitAction } from '../../../../../store/ducks/e-visits';

interface LCProps {
  room: any;
  className?: string;
}

export const LocalControls: React.FunctionComponent<LCProps> = ({ room, className }) => {
  const dispatch = useDispatch();
  const muted = useSelector((state: TStore) => state.twilio.muted);
  const cameraDisabled = useSelector((state: TStore) => state.twilio.cameraDisabled);
  const microphoneDisabled = useSelector((state: TStore) => state.twilio.microphoneDisabled);

  return (
    <>
      <ExpandIcon
        className="switch-icon"
        onClick={() => dispatch(actions.toggleLocalDisplayMode())}
      />
      <ControlsSC className={className && className}>
        {muted ? (
          <SpeakerOffIcon onClick={() => dispatch(actions.toggleMuted())} />
        ) : (
          <SpeakerIcon onClick={() => dispatch(actions.toggleMuted())} />
        )}
        {cameraDisabled ? (
          <CameraOffIcon onClick={() => dispatch(actions.toggleCameraDisabled())} />
        ) : (
          <CameraIcon onClick={() => dispatch(actions.toggleCameraDisabled())} />
        )}
        {microphoneDisabled ? (
          <MicrophoneMutedIcon onClick={() => dispatch(actions.toggleMicrophone())} />
        ) : (
          <MicrophoneIcon onClick={() => dispatch(actions.toggleMicrophone())} />
        )}
        <CallEndIcon
          onClick={() => {
            room.disconnect();
            dispatch(actions.resetTwilioRoom());
            dispatch(eVisitAction.setSingleEvent());
          }}
        />
      </ControlsSC>
    </>
  );
};

export default React.memo(LocalControls);
